import {
  Avatar,
  ClickAwayListener,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuList,
  Paper,
  Popper,
  Slide,
} from '@mui/material'
import {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { MdExitToApp, MdPerson } from 'react-icons/md'
import { useNavigate, useLocation } from 'react-router-dom'
import { GlobalContext } from '../App'
import { listaPerfis, logout, selecionaPerfil } from '../components/api'
import logo from '../css/logo.png'

const OpcoesUsuario = (
  { openOpcoesUsuario: open, setOpenOpcoesUsuario: setOpen },
  anchorRef,
) => {
  const location = useLocation()
  const navigate = useNavigate()
  const { verificaLogin, dispatch } = useContext(GlobalContext)

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) return
    setOpen(false)
  }

  const handleListKeyDown = (event) => {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen(false)
    }
  }

  const sair = async () => {
    try {
      await logout()
    } finally {
      document.cookie = 'token=; Max-Age=0; path=/; SameSite=Lax'
      localStorage.removeItem('user')
      dispatch({
        field: 'usuarioLogado',
        value: {
          id: 0,
          nome: '',
          email: '',
          programa: '',
          token: '',
          foto: '',
        },
      })
      dispatch({ field: 'notificacoes', value: [] })
      navigate('/login')
    }
  }

  const prevOpen = useRef(open)
  useEffect(() => {
    if (prevOpen.current === true && open === false) anchorRef.current.focus()
    prevOpen.current = open
  }, [anchorRef, open])

  const [perfis, setPerfis] = useState([])

  const buscaPerfis = useCallback(async () => {
    const res = await listaPerfis()
    setPerfis(res.lista || [])
  }, [])

  useEffect(() => {
    buscaPerfis()
  }, [buscaPerfis])

  const handlePerfil = (perfil) => async () => {
    await selecionaPerfil(perfil[0], perfil[1], perfil[2])
    await buscaPerfis()
    window.dispatchEvent(new Event('frameworkfl:websocket-reconnect'))
    verificaLogin(null, navigate, location)
  }

  return (
    <Popper
      style={{ zIndex: 99 }}
      open={open}
      anchorEl={anchorRef.current}
      transition
    >
      {({ TransitionProps, placement }) => (
        <Slide
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === 'bottom' ? 'center top' : 'center bottom',
          }}
        >
          <Paper>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuList autoFocusItem={open} onKeyDown={handleListKeyDown}>
                {perfis.map((perfil, perfilIndex) => (
                  <ListItem
                    key={`${perfilIndex}-profile`}
                    button
                    onClick={handlePerfil(perfil)}
                  >
                    <ListItemIcon selected style={{ minWidth: 30 }}>
                      <Avatar
                        style={{ width: 30, height: 30 }}
                        alt="Remy Sharp"
                        src={logo}
                      />
                    </ListItemIcon>
                    <ListItemText
                      style={{
                        paddingRight: 20,
                        marginLeft: 10,
                        color: perfil[4] === true ? 'black' : '#99999940',
                      }}
                    >
                      <span style={{ fontSize: '0.80rem' }}>{perfil[3]}</span>
                    </ListItemText>
                  </ListItem>
                ))}
                <ListItem button>
                  <ListItemIcon style={{ minWidth: 30 }}>
                    <MdPerson style={{ width: 20, height: 20 }} />
                  </ListItemIcon>
                  <ListItemText
                    onClick={() => navigate('/programas/usuario/usuario_senha')}
                    style={{ paddingRight: 20, marginLeft: 10 }}
                  >
                    <span style={{ fontSize: '0.80rem' }}>
                      Alterar meus dados
                    </span>
                  </ListItemText>
                </ListItem>
                <Divider />
                <ListItem button onClick={sair}>
                  <ListItemIcon style={{ minWidth: 20 }}>
                    <MdExitToApp />
                  </ListItemIcon>
                  <ListItemText style={{ paddingRight: 20 }}>
                    <span style={{ fontSize: '0.80rem' }}>Sair</span>
                  </ListItemText>
                </ListItem>
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Slide>
      )}
    </Popper>
  )
}

export default forwardRef(OpcoesUsuario)
